import Checkbox from './Checkbox.js';
export { default } from './Checkbox.js';
//# sourceMappingURL=index.js.map
